module.exports = __webpack_public_path__ + "img/youtube-greyscale.a939d484.svg";